module.exports = __webpack_public_path__ + "static/media/tutorial-treasure-trinket.4ca9e889.png";